<template>
    <div v-if="item">

        <div v-if="!mapShow">
            <div class="row my-3">
                <div class="border-bottom pb-4 mb-4">
                    <div class="row">
                        <div class="col col-md-6">
                            <div class="form-group required">
                                <label class='control-label pr-2'>Вид деятельности</label>
                                <Select2
                                    :disabled="isReadonly"
                                    class="select2"
                                    :options="kindActivityList"
                                    v-model="item.serviceType.kindActivityId"
                                    v-on:select="loadServiceTypeList(item.serviceType.kindActivityId)"
                                    style="width: 100%"
                                />
                              <div class="invalid-msg" v-if="v$.item.serviceType.kindActivityId.$error">Введите данные</div>
                            </div>
                        </div>

                        <div class="col col-md-6">
                            <div class="form-group required">
                                <label class='control-label pr-2'>Услуга</label>
                                <Select2
                                    :disabled="isReadonly"
                                    class="select2"
                                    :options="serviceTypeList"
                                    v-model="item.serviceTypeId"
                                    v-on:select="loadOrganizations"
                                    style="width: 100%"
                                />
                                <div class="invalid-msg" v-if="v$.item.serviceTypeId.$error">Введите данные</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col col-md-6">
                        <div class="form-group required">
                            <label class='control-label'>Объем предоставления услуги, занятий</label>
                            <div><input :disabled="isReadonly" class="form-control" v-model="item.count" maxlength="3"/></div>
                            <div class="invalid-msg" v-if="v$.item.count.$error">Введите корректные данные</div>
                        </div>
                    </div>

                    <div class="col  col-md-6">
                        <div class="form-group required">
                            <label class='control-label'>Периодичность предоставления услуги</label>
                            <div><input :disabled="isReadonly" class="form-control" v-model="item.period" maxlength="100"/></div>
                            <div class="invalid-msg" v-if="v$.item.period.$error">Введите данные</div>
                        </div>
                    </div>
                    </div>
                </div>

                <h5>Срок предоставления услуги</h5>
                <div class="col  col-md-3">
                    <div class="form-group required">
                        <label class='control-label'>Дата начала</label>
                        <date-component :disabled="isReadonly" v-model="item.dateBegin"/>
                        <div class="invalid-msg" v-if="v$.item.dateBegin.$error">Введите данные</div>
                    </div>
                </div>
                <div class="col  col-md-3">
                    <div class="form-group required">
                        <label class='control-label'>Дата окончания</label>
                        <date-component :disabled="isReadonly" v-model="item.dateEnd"/>
                        <div class="invalid-msg" v-if="v$.item.dateEnd.$error && v$.item.dateEnd.required.$invalid">Введите данные</div>
                        <div class="invalid-msg" v-else-if="v$.item.dateEnd.$error && v$.item.dateEnd.notBeforeFrom.$invalid">Дата должна быть не меньше даты начала</div>
                    </div>
                </div>
                <div class="col  col-md-6">
                    <div class="form-group">
                        <label class='control-label'>Расписание</label>
                        <div><textarea  :disabled="isReadonly" class="form-control" required="required" v-model="item.schedule"/></div>
                    </div>
                </div>
            </div>

            <label class="control-label">Организация</label>
            <button class="btn" title="Добавить" v-on:click="addOrganization" v-if="!isReadonly">
                <i class="fa fa-plus"></i>
            </button>

            <span class="invalid-msg" v-if="v$.item.journalImarOrganizations.$error">Необходимо указать хотя бы одну организацию</span>
            <table class="table table-custom">
                <colgroup>
                    <col width="50%"/>
                    <col width="5%"/>
                    <col width="40%"/>
                    <col width="5%" v-if="!isReadonly"/>
                </colgroup>
                <thead>
                <tr>
                    <th>Организация</th>
                    <th></th>
                    <th>Специалисты</th>
                    <th v-if="!isReadonly"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(el, index) in item.journalImarOrganizations" v-bind:key="el.id">
                    <tr v-if="!el.isDeleted">
                        <td>
                            <Select2
                                :disabled="isReadonly"
                                class="select2 mb-3"
                                :class="{'error': v$.item.journalImarOrganizations.$error && (el.organizationId == null || el.organizationId == 0)}"
                                :options="organizationList"
                                v-model="el.organizationId"
                                style="width: 100%" v-on:select="changeOrganization(el)"
                            />
                            <Select2
                                :disabled="isReadonly"
                                class="select2"
                                :options="el.addressList"
                                v-model="el.addressId"
                                style="width: 100%"
                            />
                        </td>
                        <td>

                            <button class="btn btn-sm" title="Найти на карте" v-on:click="findOnMap(el, index)">
                                <i class="far fa-map"></i>
                            </button>
                        </td>
                        <td>
                            <Select2
                                class="select2"
                                :disabled="isReadonly"
                                :settings="{multiple: true}"
                                :options="el.employeeList"
                                v-model="el.employeeIds"
                                style="width: 100%"
                            />
                        </td>
                        <td class="icon" v-if="!isReadonly">
                            <i
                                class="fas fa-trash ico-delete"
                                v-on:click="deleteOrganization(el)"
                            ></i>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>

            <div class="">
                <div class="float-right d-flex align-items-center">
                    <button-component class="btn btn-primary mx-2" v-if="!isReadonly" v-on:click="save">Сохранить
                    </button-component>
                    <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">
                        Закрыть
                    </button-component>
                </div>
            </div>


        </div>

        <div v-else>
            <l-map v-if="mapShow" ref="myMap" style="height:50vh"
                   :zoom="10"
                   :center="mapCurrentCenter">
                <l-tile-layer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                ></l-tile-layer>
                <template v-for="el in organizationFullList" :key="el.id">
                    <l-marker v-if="el.lat && el.lng"
                              :lat-lng="el" :icon="getMarkerIcon(el.kindActivityId, mapAddressId == el.addressId)"
                    >
                        <l-popup>
                            <div>{{ el.name }}</div>
                            <div>{{ el.address }}</div>
                            <div  class="link pt-2" v-on:click="setAddress(el)" v-if="!isReadonly">Выбрать</div>
                        </l-popup>
                    </l-marker>
                </template>

            </l-map>
            <div class="mt-1">
                <div class="float-right">
                    <button-component type="button" kind="secondary" class="btn btn-default btn-sm" v-on:click="mapShow=false">Закрыть карту</button-component>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import API from '../api/imar'
import Utils from "../../../common/utils";
import Constants from '../../../common/constants'
import {required, numeric, minValue} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import {LMap, LMarker, LTileLayer, LPopup} from "@vue-leaflet/vue-leaflet";
import {latLng} from "leaflet";
import ButtonComponent from "@/common/ui/ButtonComponent";

const selectValidator = (value) => Number(value) > 0;

function organizationValidator(value) {
    if (value === null || value === undefined || value.length === 0)
        return true;

    var isValid = true;
    value.forEach(function (el) {
        if (!el.organizationId || el.organizationId == 0)
            isValid = false;
    });
    return isValid;
}

export default {
    name: "ImarServiceCard",
    components: {
        ButtonComponent,
        DateComponent,
        LMap,
        LMarker,
        LTileLayer,
        LPopup
    },
    props: {
        journalId: Number,
        cardId: {
            type: Number,
            required: false,
            default: null
        },
        isReadonly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    created() {
        this.loadPage();
        Utils.loadSelectOptions("kindActivity", this.kindActivityList);

    },
    data() {
        return {
            item: {
                journalId: 0,
                serviceType: {kindActivityId: 0},
                serviceTypeId: 0,
                journalImarOrganizations: [{
                    employeeList: [],
                    employeeIds: [],
                    organizationId: 0,
                    addressId: 0,
                    addressList: [
                        {id: 0, text: Constants.emptySelectOptionText, selected: true},
                    ]
                }]
            },

            organizationList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            kindActivityList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            serviceTypeList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            organizationFullList: [],

            mapShow: false,
            mapCurrentCenter: latLng(56.30, 44.01),
            mapIndex: null,
            mapAddressId: null,
        };
    },
    methods: {
        getMarkerIcon(kindActivityId, isTemp) {
            return Utils.getMarkerIcon(kindActivityId, isTemp);
        },
        setAddress(el) {
            var orgItem = this.item.journalImarOrganizations[this.mapIndex];
            if (orgItem.organizationId != el.id) {
                orgItem.organizationId = el.id;
                this.changeOrganization(orgItem);
            }
            orgItem.addressId = el.addressId;
            this.mapShow = false;
            this.mapIndex = null;
        },
        findOnMap(el, index) {
            this.mapShow = true;
            this.mapIndex = index;
            this.mapAddressId = el.addressId;
            var onMap = null;
            if (el.addressId) {
                onMap = this.organizationFullList.find(x => x.addressId == el.addressId);
            } else if (el.organizationId) {
                onMap = this.organizationFullList.find(x => x.id == el.organizationId);
            }
            if (onMap) {
                this.mapCurrentCenter = latLng(onMap.lat, onMap.lng);
            }
        },
        addOrganization() {
            if (this.item.journalImarOrganizations == null)
                this.item.journalImarOrganizations = [];
            this.item.journalImarOrganizations.push({
                employeeList: [],
                employeeIds: [],
                organizationId: 0,
                addressId: 0,
                addressList: [
                    {id: 0, text: Constants.emptySelectOptionText, selected: true},
                ]
            });
        },
        deleteOrganization(el) {
            if (el.id > 0) {
                el.isDeleted = true;
            } else {
                this.item.journalImarOrganizations.splice(
                    this.item.journalImarOrganizations.indexOf(el),
                    1
                );
            }
        },
        changeOrganization(el) {
            this.loadEmployees(el);
            this.loadAddresses(el);
        },
        loadServiceTypeList(kindActivityId) {
            Utils.loadSelectOptions(
                "serviceType",
                this.serviceTypeList,
                {kindActivityId: kindActivityId},
                true
            );
        },
        loadEmployees(el) {
            //var self = this;
            if (el.organizationId) {
                API.loadEmployees(el.organizationId).then((response) => {
                    el.employeeList = response.data;
                });
            } else {
                el.employeeList = [];
            }
        },
        loadAddresses(el) {
            if (el.organizationId) {
                API.loadAddresses(el.organizationId).then((response) => {
                    el.addressList = response.data;
                    el.addressList.unshift({id: 0, text: Constants.emptySelectOptionText, selected: true});
                });
            } else {
                el.addressList = [
                    {id: 0, text: Constants.emptySelectOptionText, selected: true}
                ];
            }
        },
        loadOrganizations() {
            var self = this;
            if (self.item.serviceTypeId > 0) {
                API.loadOrganizations(self.item.serviceTypeId).then((response) => {
                    self.organizationList = response.data;
                    self.organizationList.unshift({id: 0, text: Constants.emptySelectOptionText, selected: true});
                });
                API.loadOrganizationsOnMap(self.item.serviceTypeId).then((response) => {
                    self.organizationFullList = response.data.items;
                });
            } else {
                self.organizationList = [
                    {id: 0, text: Constants.emptySelectOptionText, selected: true}
                ];
                self.organizationFullList = [];
            }
        },
        loadPage() {
            var self = this;
            if (self.cardId) {
                API.find(self.cardId).then(response => {
                    self.item = response.data;
                    self.loadServiceTypeList(self.item.serviceType.kindActivityId);
                    self.loadOrganizations();
                    self.item.journalImarOrganizations.forEach(function (el) {
                        if (el.addressId == null)
                            el.addressId = 0;
                        el.employeeIds = [];
                        if (el.journalImarOrganizationSpecialists) {
                            el.journalImarOrganizationSpecialists.forEach(function (n) {
                                el.employeeIds.push(n.employeeId);
                            });
                        }

                        self.changeOrganization(el);
                    });
                });
            } else {
                self.item.journalId = self.journalId;
            }
        },
        save() {
            var self = this;

            self.v$.$touch();
            if (self.v$.$invalid) {
                Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
                return;
            }

            self.item.journalImarOrganizations.forEach(function (el) {
                if (el.addressId == 0)
                    el.addressId = null;
                el.journalImarOrganizationSpecialists = [];
                if (el.employeeIds) {
                    el.employeeIds.forEach(function (n) {
                        el.journalImarOrganizationSpecialists.push({employeeId: n});
                    });
                }
            });

            API.save(self.item).then(function (response) {
                Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
                if (response.data.success) {
                    self.$emit('save');
                }
            });
        },
        close() {
            this.$emit('close');
        },
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
        return {
            item: {
                serviceType: {
                  kindActivityId: {required, selectValidator}
                },
                serviceTypeId: {required, selectValidator},
                count: {required, numeric, minValue: minValue(1)},
                period: {required},
                dateBegin: {required},
                dateEnd: {
                    required,
                    notBeforeFrom: (value) => {
                        if (!value) return true;
                        if (!this.item.dateBegin) return true;
                        return new Date(value) >= new Date(this.item.dateBegin);
                    }
                },
                schedule: {},
                journalImarOrganizations: {required, organizationValidator}
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after {
    content: "*";
    color: red;
}

.form-check.required .control-label:after {
    content: "*";
    color: red;
}

.invalid-msg {
    color: red;
    font-size: 0.75rem;
}
</style>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.fa, .fas, .far {
    color: $gray-medium;
}

.select2::v-deep {
    .select2-container {
        width: 100% !important;
        max-width: 100% !important;

    }

    .select2-container--default .select2-selection--single {
        height: calc(2.25rem + 2px) !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: 7px !important;
    }
}

.modal-content {
    padding: 24px;
    border-radius: 12px !important;
    border: none;
    box-shadow: none;
}

.w100 .select2-container {
    width: 100% !important;
}

.select2-container--open {
    z-index: 2000;
}

.link {
    cursor: pointer;
    color: #438EF0;
}

.error .select2-container--default .select2-selection--single {
    border-color: red;
}
</style>